import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';

import { UIModule } from '../../shared/ui/ui.module';

import { SharedModule } from '../shared/shared.module';
import { LayoutComponent } from './layout/layout.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FormsModule } from '@angular/forms';
import { SearchBarComponent } from './topbar/search-bar/search-bar.component';
import { CoreModule } from 'src/app/core/core.module';
import { DashboardService } from 'src/app/pages/dashboard/services/dashboard.service';
import { WidgetFiltersModule } from 'src/app/pages/dashboard/widget/filters/widget-filters.module';
@NgModule({
  declarations: [LayoutComponent, TopbarComponent, SearchBarComponent],
  imports: [
    CommonModule, RouterModule, NgbDropdownModule,
    SimplebarAngularModule,
    UIModule, SharedModule, 
    FormsModule,
    CoreModule,
    WidgetFiltersModule,
  ],
  exports: [LayoutComponent, TopbarComponent],
  providers: [DashboardService],
})
export class DetachedLayoutModule { }
